module.exports = __webpack_public_path__ + "static/media/project-id.6596e675.png";